import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLibros } from "./useLibros";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SkeletonCard from "../../../components/Skeleton/SkeletonCard";

import Modalibro from "../../../components/modalLibro/ModalLibro";

const rut = "https://www.ricardosalinas.com/images/libros/";

const Recomendados = ({ books }) => {

    const navigate = useNavigate();
    const { libros, isLoading } = useLibros({ books });
    const [t, i18n] = useTranslation("biblioteca");
    const [t2] = useTranslation("home");
    const [t3] = useTranslation("global");
    const [t4] = useTranslation("ideas_libertad");
    // Endless scroll
    const [offset, setOffset] = useState(0);
    const limit = 12;
    const [loadingMore, setLoadingMore] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [allBooks, setAllBooks] = useState([]);
    const [items, setItems] = useState([]);
    const [featuredBook, setFeaturedBook] = useState(null);
    const [visibleCount, setVisibleCount] = useState(11);
    const [hasMore, setHasMore] = useState(true);
    const [search, setSearch] = useState('');
    const [sort, setSort] = useState('recent');
    const [book, setBook] = useState(null);
    const [searchInput, setSearchInput] = useState('');
    const [initialLoadFinished, setInitialLoadFinished] = useState(false);
    const noResultsRef = useRef(null);

    useEffect(() => {
        if (libros) setBook(libros);
    }, [libros]);

    // Modal
    const [isModalOpen2, setIsModalOpen2] = useState(false);

    const [variable1, setVariable1] = useState("");
    const [variable2, setVariable2] = useState("");
    const [variable3, setVariable3] = useState("");
    const [variable4, setVariable4] = useState("");
    const [variable5, setVariable5] = useState("");
    const [variable6, setVariable6] = useState("");
    const [variable7, setVariable7] = useState("");
    const [variable8, setVariable8] = useState("");
    const [variable9, setVariable9] = useState("");
    const [variable10, setVariable10] = useState("");

    const openModal2 = (
        value1,
        value2,
        value3,
        value4,
        value5,
        value6,
        value7,
        value8,
        value9,
        idlibro
    ) => {

        setVariable1(value1);
        setVariable2(value2);
        setVariable3(value3);
        setVariable4(value4);
        setVariable5(value5);
        setVariable6(value6);
        setVariable7(value7);
        setVariable8(value8);
        setVariable9(value9);
        setVariable10(idlibro);
        setIsModalOpen2(true);
        navigate(`/${i18n.language}/recomendados?libro=${idlibro}`);
    };

    const [modalData, setModalData] = useState({});

    const closeModal2 = () => setIsModalOpen2(false);

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString(i18n.language, {
            year: "numeric",
        });
    };

    const normalizeText = (text) => {
        return text
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/library/nbooks2?offset=0&next=200&sitioid=2&lenguaje=${i18n.language}`
            );

            return response.data;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const clearSearch = () => {

        setSearchInput('');
        setSearch('');
        setVisibleCount(12);
    };

    const loadMore = () => {

        const newVisibleCount = visibleCount + 12;

        setVisibleCount(newVisibleCount);

        setItems(allBooks.slice(0, newVisibleCount));

        setHasMore(newVisibleCount < allBooks.length);
    };

    useEffect(() => {

        const loadInitialBooks = async () => {

            const data = await fetchData();
        
            const booksWithoutBanner = data;
        
            setAllBooks(booksWithoutBanner);
        
            setInitialLoadFinished(true);
        };


        loadInitialBooks();

    }, [i18n.language]);

    useEffect(() => {

        let filtered = [...allBooks];

        // BUSQUEDA
        if (search.trim()) {

            filtered = filtered.filter(book => {

                const normalizedSearch = normalizeText(search);
            
                return (
                    normalizeText(book.titulo)
                        .includes(normalizedSearch) ||
            
                    normalizeText(book.descripcion)
                        .includes(normalizedSearch)
                );
            
            });
        }

        // ORDENAMIENTO
        filtered.sort((a, b) => {

            const dateA = new Date(a.fecha);
            const dateB = new Date(b.fecha);

            if (sort === 'recent') {
                return dateB - dateA;
            }

            return dateA - dateB;
        });

        if (filtered.length > 0) {

            setFeaturedBook(filtered[0]);

            setItems(
                filtered.slice(0, visibleCount + 1)
            );

            setHasMore(
                visibleCount + 1 < filtered.length
            );

        } else {

            setFeaturedBook(null);
            setItems([]);
            setHasMore(false);
        }

    }, [allBooks, search, sort, visibleCount]);


    const var_img = useRef(0);
    const imageLoaded = () => {
        var_img.current += 1;
    };

    const BookSkeleton = () => (
        <div className="_ngcontent-ng-c54415964 app-biblioteca-book-card">
            <article role="button" tabIndex="0" className="biblioteca-book-card">
                <div className="biblioteca-book-card biblioteca-book-card--skeleton">
                    <div className="biblioteca-book-card__inner">
                        <div className="biblioteca-book-card__media skeleton-box" />
                        <div className="biblioteca-book-card__copy">
                            <div className="skeleton-line w-40" />
                            <div className="skeleton-line w-70" />
                            <div className="skeleton-line w-90" />
                            <div className="skeleton-line w-60" />
                        </div>
                    </div>
                </div>
            </article>
        </div>
    );

    const BannerSkeleton = () => (
        <article className="biblioteca-banner biblioteca-banner--skeleton">
            <div className="biblioteca-banner__media">
                <div className="skeleton-box biblioteca-banner__image" />
            </div>
            <div className="biblioteca-banner__copy">
                <div className="skeleton-line w-30" />
                <div className="skeleton-line w-60" />
                <div className="skeleton-line w-80" />
            </div>

        </article>
    );

    useEffect(() => {

        if (
            initialLoadFinished &&
            search.trim()
        ) {
    
            requestAnimationFrame(() => {
    
                noResultsRef.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
    
            });
    
        }
    
    }, [search, initialLoadFinished]);

    return (
        <>
            <div className="_ngcontent-ng-c3603033847">
                <header class="biblioteca-header">
                    <div class="biblioteca-header__inner">
                        <h1 class="biblioteca-header__title">{t("2026.title")}</h1>
                        <nav aria-label="Categorías" class="biblioteca-header__categories"><a
                            class="biblioteca-header__category"
                            href={"/" + i18n.language + "/biblioteca"}> {t2("2026.leyenda-btn")} </a><a

                                class="biblioteca-header__category biblioteca-header__category--active"
                                href={"/" + i18n.language + "/recomendados"}> {t2("2026.leyenda-btn2")} </a>
                        </nav>
                        <div aria-label="Controles de biblioteca" class="biblioteca-header__controls">
                            <label class="biblioteca-header__control biblioteca-header__control--sort">
                                <span class="biblioteca-header__visually-hidden">{(t4('filtro.ordenar-fecha2'))}</span>
                                <select
                                    value={sort}
                                    onChange={(e) => {
                                        setSort(e.target.value);
                                        setVisibleCount(12);
                                    }}
                                >
                                    <option value="recent">{(t4('filtro.ordenar-fecha-op1'))}</option>
                                    <option value="old">{(t4('filtro.ordenar-fecha-op2'))}</option>
                                </select>
                            </label>
                            <div class="biblioteca-header__control biblioteca-header__control--search">
                                <label>
                                    <span class="biblioteca-header__visually-hidden">{(t4('filtro.buscar'))}</span>
                                    <input
                                        type="search"
                                        placeholder={(t4('filtro.buscar'))}
                                        value={searchInput}
                                        onChange={(e) => {
                                            setSearchInput(e.target.value);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                setSearch(searchInput);
                                                setVisibleCount(12);
                                            }
                                        }}
                                    />

                                    {searchInput && (
                                        <button
                                            type="button"
                                            aria-label="Limpiar búsqueda"
                                            class="blog-header__search-button"
                                            onClick={clearSearch}
                                        >
                                            <img
                                                src="/assets/img2026/cerrar-cancelar.svg"
                                                alt="cancelar"
                                                aria-hidden="true"
                                            />
                                        </button>
                                    )}
                                    {!searchInput && (
                                        <button type="button" aria-label="Buscar" class="biblioteca-header__search-button" onClick={() => {
                                            setSearch(searchInput);
                                            setVisibleCount(12);
                                        }}>
                                            <img src="/assets/img2026/logo_search.svg" alt="Buscar" aria-hidden="true" />
                                        </button>)}
                                </label>
                            </div>
                        </div>

                    </div>
                </header>
            </div>
            <div>

                <div className="_ngcontent-ng-c3603033847">

                    <article role="button" tabIndex="0" className="biblioteca-banner">
                        <div className="biblioteca-banner__media">
                            <video className="biblioteca-banner__image biblioteca-header-banner" poster="https://ricardosalinas.com/blog/images/Segmento-8.jpg" controls="true">
                                <source src="https://ricardosalinas.com/blog/images/Mis-libros-de-cabecera.mp4" type="video/mp4" />
                                <source src="https://ricardosalinas.com/blog/images/Mis-libros-de-cabecera.webm" type="video/webm" />
                            </video>
                        </div>
                        <div className="biblioteca-banner__copy">

                            <h2 className="biblioteca-banner__title">
                            {i18n.language === "en" ? "My most influential books" : "Mis libros de cabecera"}
                                
                            </h2>
                            <p className="biblioteca-banner__summary">
                            {i18n.language === "en" ? "These are some of the books in my personal library, and which I have selected as special recommendations for you." : "Estos son algunos de los libros que integran mi biblioteca personal y he seleccionado como recomendaciones especiales para ti."}
                                
                            </p>
                            <p className="biblioteca-banner__summary">
                                <b>{i18n.language === "en" ? "Get to know them!" : "¡Conócelos!"}</b>
                            </p>
                        </div>
                    </article>
                </div>


                {/*
                <div className="_ngcontent-ng-c3603033847">

                    {!initialLoadFinished ? (

                        <BannerSkeleton />

                    ) : featuredBook ? (

                        <article role="button" tabIndex="0" className="biblioteca-banner">
                            <div className="biblioteca-banner__media">
                                <img
                                    className="biblioteca-banner__image biblioteca-banner__image--mobile"
                                    src={rut + featuredBook.imagen}
                                    alt={featuredBook.titulo}
                                />
                                <img
                                    className="biblioteca-banner__image biblioteca-banner__image--desktop biblioteca-header-banner"
                                    src={rut + featuredBook.imagen}
                                    alt={featuredBook.titulo}
                                />
                            </div>
                            <div className="biblioteca-banner__copy">

                                <h2 className="biblioteca-banner__title">
                                    {featuredBook.titulo.split(":")[0]}
                                </h2>
                                <p className="biblioteca-banner__author">{featuredBook.autor}</p>
                                <p className="biblioteca-banner__summary">
                                    {featuredBook.descripcion.substring(0, 155) + "..."}
                                </p>
                                <button
                                    className="biblioteca-book-card__link"
                                    onClick={() => openModal2(rut + featuredBook.imagen, featuredBook.imagen.substring(0, featuredBook.imagen.length - 4), featuredBook.titulo, featuredBook.descripcion, featuredBook.autor, featuredBook.editorial, formatDate(featuredBook.fecha), featuredBook.blog, i18n.language, featuredBook.id)}
                                >
                                    <a href="#">{t2("2026.bookmore")}</a>
                                </button>
                            </div>
                        </article>

                    ) : (

                        <div class="_nghost-ng-c2806470063">
                            <section class="blog-hero-article">
                                <div class="blog-hero-article__inner">
                                    <div className="blog-empty-state">
                                        <h2>{t3("general.noresults")}</h2>
                                        <p>
                                            {t3("general.noresults3")}
                                            {searchInput && `: "${searchInput}"`}
                                        </p>
                                    </div>
                                </div>
                            </section>
                        </div>

                    )
                    }
                </div>
 */}

                <div
                    id="no-results-div-l"
                    ref={noResultsRef}
                    className="_ngcontent-ng-c3603033847"
                >

                    {!initialLoadFinished ? (

                        <></>

                    ) : featuredBook ? (

                        <></>

                    ) : (

                        <div class="_nghost-ng-c2806470063">
                            <section class="blog-hero-article">
                                <div class="blog-hero-article__inner">
                                    <div className="blog-empty-state">
                                        <h2>{t3("general.noresults")}</h2>
                                        <p>
                                            {t3("general.noresults3")}
                                            {searchInput && `: "${searchInput}"`}
                                        </p>
                                    </div>
                                </div>
                            </section>
                        </div>

                    )
                    }
                </div>

                <div className="_ngcontent-ng-c3603033847">
                    <section className="biblioteca-books" aria-label="Lista de libros">

                        {
                            initialLoadFinished ? (

                                items.length > 0 ? (

                                    items.map((item, index) => (
                                        <div key={index} className="_ngcontent-ng-c54415964 app-biblioteca-book-card">
                                            <article role="button" tabIndex="0" className="biblioteca-book-card" >
                                                <div className="biblioteca-book-card__inner">
                                                    <div onClick={() => openModal2(rut + item.imagen, item.imagen.substring(0, item.imagen.length - 4), item.titulo, item.descripcion, item.autor, item.editorial, formatDate(item.fecha), item.blog, i18n.language, item.id)} className="biblioteca-book-card__media">
                                                        <img loading="lazy" onLoad={imageLoaded} src={rut + item.imagen} alt={item.titulo} />
                                                    </div>

                                                    <div className="biblioteca-book-card__copy">

                                                        <h3 className="biblioteca-book-card__title">
                                                            {item.titulo.split(":")[0]}
                                                        </h3>
                                                        <p className="biblioteca-book-card__author">{item.autor}</p>
                                                        <p className="biblioteca-book-card__summary">
                                                            {item.descripcion.substring(0, 155) + "..."}
                                                        </p>
                                                        <div className="biblioteca-book-card__buttons">
                                                            <button onClick={() => openModal2(rut + item.imagen, item.imagen.substring(0, item.imagen.length - 4), item.titulo, item.descripcion, item.autor, item.editorial, formatDate(item.fecha), item.blog, i18n.language, item.id)}
                                                                className="biblioteca-book-card__link"
                                                            >
                                                                <a  href="#">
                                                                    {t2("2026.bookmore")}
                                                                </a>
                                                            </button>
                                                            {item.blog && (
                                                                <button onClick={() => {
                                                                    window.location.href = `/blog/${item.blog}`;
                                                                }}
                                                                    className="biblioteca-book-card__link"
                                                                >
                                                                    <a
                                                                        href={"/blog/" + item.blog}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {i18n.language === "en" ? "Read blog" : "Leer blog"}
                                                                    </a>

                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </article>
                                        </div>
                                    ))

                                ) : (
                                    <>

                                    </>

                                )

                            ) : (

                                Array.from({ length: 6 }).map((_, i) => (
                                    <BookSkeleton key={i} />
                                ))

                            )
                        }

                    </section>

                    <div className="reflexiones-videos__load-more">
                        {hasMore && (
                            <button
                                onClick={loadMore}
                                disabled={loadingMore}
                                className="reflexiones-videos__load-more-button typo-book-title"
                            >
                                {loadingMore
                                    ? t("2026.cargando")
                                    : t("2026.cargar")}
                            </button>
                        )}
                    </div>
                </div>

                <Modalibro
                    isOpen={isModalOpen2}
                    closeModal={closeModal2}
                    variable1={variable1} //ruta con imagen
                    variable2={variable2} //titulo
                    variable3={variable3} //descripcion
                    variable4={variable4} //autor
                    variable5={variable5} //editorial
                    variable6={variable6} //año
                    variable7={variable7} //año
                    variable8={variable8} //año
                    variable9={variable9} //año
                    id_idea={variable10}
                />
            </div>
        </>
    );
};

export default Recomendados;